import { Typography } from '@crossnokaye/ux-common';

import { Stack } from '@/ux-common/components/stack/stack';

export const EmptyDeviceAttributeList = () => (
  <Stack className="text-sm text-muted-foreground text-center py-2">
    <Typography variant="body">No trend points available for this device</Typography>
  </Stack>
);
